import { useParams } from "react-router-dom";
import { useUserReceiveConfiguration } from "../../../../api/hooks/useUserReceiveConfiguration";
import { UserBluePenguinReceiveConfiguration } from "./UserBluePenguinReceiveConfiguration";
import { UserStrikeReceiveConfiguration } from "./UserStrikeReceiveConfiguration";
import { FlexLoadingBlock } from "@synota-io/synota-shared-ui";
import { Typography } from "@mui/material";

const empty = (
  <Typography variant="subtitle1" color="warning">
    No configuration available
  </Typography>
);

export const UserReceiveConfiguration = () => {
  const params = useParams();

  const { configuration, isPending: isPendingConfiguration } = useUserReceiveConfiguration({
    id: params.id,
  });

  if (isPendingConfiguration) {
    return <FlexLoadingBlock />;
  }

  if (!configuration) {
    return empty;
  }

  if ("BluePenguinConfiguration" in configuration) {
    return <UserBluePenguinReceiveConfiguration configuration={configuration} />;
  }

  if ("StrikeConfiguration" in configuration) {
    return <UserStrikeReceiveConfiguration configuration={configuration} />;
  }

  return empty;
};
